import React, { useEffect } from 'react';
import Iconify from 'src/components/Iconify';
import DocumentCanvas from './DocumentCanvas';
import CanvasReadOnly from './canvas/CanvasReadOnly';
import EscalaDocumento from './EscalaDocumento';
import { DOCUMENTO_DESIGN as D } from '../EditorDocumento.design';

// Pré-visualização em modal, no espírito de um leitor de PDF: barra escura com
// título e fechar, folha em tamanho real (ou reduzida só o bastante para caber na
// largura) sobre fundo escuro. Substitui o painel lateral, que espremia o
// documento numa coluna estreita. O conteúdo é o mesmo componente de leitura do
// editor, então o que aparece aqui é o que sai no PDF e no link público.
export default function VisualizadorDocumento({
  proposta,
  modoCanvas = false,
  isModelo = false,
  titulo = 'Como o cliente vai ver',
  subtitulo = 'Igual ao PDF e ao link público',
  onClose
}) {
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    // Trava a rolagem da página por baixo enquanto o visualizador está aberto.
    const overflowAnterior = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', handler);
      document.body.style.overflow = overflowAnterior;
    };
  }, [onClose]);

  const paginas = modoCanvas ? (proposta?.canvas?.paginas?.length || 1) : 0;
  const detalhe = paginas ? `${subtitulo} · ${paginas} ${paginas === 1 ? 'página' : 'páginas'}` : subtitulo;

  return (
    <div className={D.viewer} role="dialog" aria-modal="true" aria-label={titulo}>
      <div className={D.viewerBar}>
        <Iconify icon="mdi:file-pdf-box" width={20} className="text-[#ECEAF3]/70 flex-shrink-0" />
        <div className="min-w-0 flex-1">
          <p className={D.viewerTitle}>{titulo}</p>
          <p className={D.viewerSub}>{detalhe}</p>
        </div>
        <span className={D.viewerHint}>Esc para fechar</span>
        <button type="button" className={D.viewerClose} onClick={onClose} title="Fechar" aria-label="Fechar pré-visualização">
          <Iconify icon="eva:close-outline" width={18} />
        </button>
      </div>

      <div className={D.viewerBody} onClick={onClose}>
        <div className="max-w-[794px] mx-auto" onClick={e => e.stopPropagation()}>
          <EscalaDocumento>
            <div className="pointer-events-none select-none">
              {modoCanvas
                ? <CanvasReadOnly proposta={proposta} />
                : <DocumentCanvas proposta={proposta} onChange={() => {}} readOnly isModelo={isModelo} />}
            </div>
          </EscalaDocumento>
        </div>
      </div>
    </div>
  );
}
